// extracted by mini-css-extract-plugin
export default {"container":"Dialog-container___joP9e","title":"Dialog-title___ZZm8F","content":"Dialog-content___C-IFH","actions":"Dialog-actions___+NbqS"};